import { isErrorResponse } from "../IsErrorResponse";
export const socketConnection = (message, meta) => {
    return {
        resolve(_data) { },
        reject(_data) { },
        deactivate() { this.query = undefined; },
        onData(data) {
            if (isErrorResponse(data)) {
                this.reject(data);
            }
            this.resolve(data);
        },
        onError(data) {
            this.reject(data);
        },
        query: message,
        meta
    };
};
//# sourceMappingURL=SocketConnection.js.map